import React, { useState } from "react";
import { useEffect } from "react";
import { Roulette } from "src/ui/components/roulette";
import styles from "./styles.module.scss";
import { useHistory } from "react-router";
import { useSpinStatus } from "src/application/useCases/spinStatus";
import { useRouletteStorage } from "src/services/rouletteAdapter";
import { useQuery } from "src/hooks/useQuery";
import { useAwardsStorage } from "src/services/awardsAdapter";
import { useAwards } from "src/application/useCases/getAwards";
import { isEmpty } from "src/lib/isEmpty";
import { Option } from "src/domain/roulette";
import { useUserStorage } from "src/services/userAdapter";
import { useReward } from "src/services/rewardAdapter";
import { getItemFromArrayByProbability } from "src/lib/getItemFromArrayByProbability";

import Bebel from "../../../assets/images/Bebel.png";
import Estrela from "../../../assets/images/Estrela.png";
import Iara from "../../../assets/images/Iara.png";
import ArcoIris from "../../../assets/images/arco-iris.png";
import { isValidEmail } from "src/lib/isValidEmail";

const Home: React.FC = () => {
  const { checkSpinStatus } = useSpinStatus();
  const { toSpin, isSpinning } = useRouletteStorage();
  const { updateUser, user } = useUserStorage();
  const { award, updateAwards, awards, updateAward } = useAwardsStorage();
  const { getAwardsPerSubscriberLevel } = useAwards();
  const { winner, updateWinner, code, updateCode, setRouletteEvent } =
    useRouletteStorage();
  const { register } = useReward();
  const [isFrame, setIsFrame] = useState(false);
  const query = useQuery();
  const history = useHistory();

  useEffect(() => {
    const [email, name, type, frame] = query.getAll([
      "email",
      "name",
      "type",
      "frame",
    ]);

    const awards: Option[] = getAwardsPerSubscriberLevel(type);

    if (frame) {
      updateAwards(awards);
      setIsFrame(true);

      window.addEventListener("message", async (e: any) => {
        if (isValidEmail(e.data.email)) {
          try {
            history.replace({ search: "" });
            e.preventDefault();
            setRouletteEvent(e);
            updateUser({
              email: e.data.email,
              first_name: e.data.name,
              type: type,
            });
            const winnerIndex = getItemFromArrayByProbability(awards);
            updateWinner(winnerIndex);
            checkSpinStatus({ email: e.data.email, type }).then(
              async ({ data }) => {
                const { status } = data;
                if (status === "1") {
                  const { slug } = awards[winnerIndex];
                  const _user = {
                    email: e.data.email,
                    first_name: e.data.name,
                    type: type,
                  };
                  await register({ ..._user, prize: slug });

                  toSpin();
                } else {
                  e.source.postMessage("error", e.origin);
                }
              }
            );
          } catch {
            e.source.postMessage("error", e.origin);
          }
        }
      });
    } else {
      ![email, type].every((e) => !isEmpty(e)) && history.push("/desabilitado");
      checkSpinStatus({ email, type })
        .then(({ data }) => {
          const { status, attempt } = data;
          updateAwards(awards);
          updateUser({ email, type, first_name: name });

          if (status !== "1") {
            updateAward(awards.find((item) => item.slug === attempt.prize));
            updateCode(attempt.source);
          } else {
            updateWinner(getItemFromArrayByProbability(awards));
          }

          history.replace({ search: "" });
        })
        .catch((e) => {
          history.push("/desabilitado");
        });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const trySpin = async () => {
    try {
      const { slug } = awards[winner];
      const { data } = await register({ ...user, prize: slug });
      if (user.type === "5") {
        updateCode(data.promocode);
      } else {
        updateCode(data.promoitem);
      }
      toSpin();
    } catch {
      history.push("/desabilitado");
    }
  };

  return (
    <div className={!isFrame ? styles.homeBestFriday : styles.home}>
      {!isFrame && (
        <img className={styles.rainbow} src={ArcoIris} alt="arco iris" />
      )}
      <div className={styles.homeContent}>
        {!isFrame && (
          <div className={styles.personas}>
            <img src={Bebel} alt="Bebel" />
            <img src={Iara} alt="Iara" />
            <img src={Estrela} alt="Estrela" />
          </div>
        )}
        <>
          {/* {award && <Confetti width={width} height={height} />} */}
          <Roulette />
          <div className={styles.spinWrapper}>
            {!isFrame && (
              <>
                {!award ? (
                  <>
                    <strong className={styles.contrast}>Aproveite!</strong>
                    <p>
                      Gire a roleta e{" "}
                      <strong>
                        ganhe um
                        {user.type === "4" ? " presente digital" : " desconto "}
                      </strong>
                      agora mesmo!
                    </p>
                    <button
                      id="btn-spin"
                      className={styles.yellowButton}
                      onClick={() => (!isSpinning ? trySpin() : {})}
                    >
                      GIRAR
                    </button>
                  </>
                ) : (
                  <>
                    <strong className={styles.contrast}>Parabéns!</strong>
                    {user.type === "4" && (
                      <p>
                        Você ganhou acesso a um{" "}
                        <strong className={styles.yellowContrast}>
                          {award?.name || ""}
                        </strong>{" "}
                        exclusivo {"<3"}
                        <br />
                        Clique no botão para resgatar o brinde:
                      </p>
                    )}
                    {user.type === "5" && (
                      <p>
                        Você ganhou{" "}
                        <strong className={styles.yellowContrast}>
                          {` ${award.option} `}{" "}
                        </strong>{" "}
                        de desconto. <br />
                        Acesse sua conta na Loja Leiturinha para garantir seu
                        prêmio agora mesmo.
                        <br />
                        <br />
                        Aqui está seu código promocional:
                        <br />
                        <strong className={styles.yellowContrast}>
                          {` ${code} `}
                        </strong>
                        <br />
                      </p>
                    )}
                    <a
                      href={
                        user.type === "4"
                          ? `https://leiturinha.com.br/premio_roleta/?slug=${
                              award?.slug || ""
                            }`
                          : `https://loja.leiturinha.com.br`
                      }
                      className={styles.blueButton}
                    >
                      RESGATAR PRESENTE
                    </a>
                    <p className={styles.smallText}>
                      FIQUE DE OLHO NA SUA CAIXA DE E-MAIL,{" "}
                      <strong className={styles.yellowContrast}>
                        DESCONTOS ESPECIAIS
                      </strong>{" "}
                      ESTÃO CHEGANDO
                    </p>
                  </>
                )}
              </>
            )}
          </div>
        </>
      </div>
    </div>
  );
};

export { Home };
